import type { RouterConfig } from "@nuxt/schema";
import { useRequestURL, useRuntimeConfig } from "nuxt/app";

const tenantPrefix = "/:tenant()";

// The dependency embeds root domains at build time; Nitro must read them at runtime.
export default {
  routes(routes) {
    const { hostname } = useRequestURL();
    const { rootDomains = [], customDomains = {} } = useRuntimeConfig().public;
    const customDomainRoute = customDomains[hostname];

    if (customDomainRoute) {
      return routes
        .filter(route => !route.path.startsWith(tenantPrefix))
        .filter(route => route.path.startsWith(`/${customDomainRoute}`))
        .map(route => ({
          ...route,
          path: route.path.replace(`/${customDomainRoute}`, ""),
        }));
    }

    const rootDomain = rootDomains.find(domain => hostname.endsWith(domain));
    if (!rootDomain) return routes;
    if (hostname === rootDomain) {
      return routes.filter(route => !route.path.startsWith(tenantPrefix));
    }

    return routes.map(route => ({
      ...route,
      path: route.path.startsWith(tenantPrefix)
        ? route.path.replace(tenantPrefix, "")
        : route.path,
    }));
  },
} satisfies RouterConfig;
